import React from 'react';
import { useIntl } from 'react-intl';

import msWordEditorLogoSrc from '~/assets/images/logo-microsoft-word.svg';
import CardList from '~/ui/components/CardList/CardList';

import DocumentEditingDetailCard from './DocumentEditingDetailCard';

function DocumentEditingIntegrations() {
  const intl = useIntl();

  const integrations = [
    {
      logoSrc: msWordEditorLogoSrc,
      title: 'Microsoft Word',
    },
  ];

  return (
    <CardList
      title={intl.formatMessage({
        id: 'DocumentEditingIntegrations.title',
        defaultMessage: 'Document Editing',
        description: 'Title for document editing integrations section',
      })}
    >
      {integrations.map(({ logoSrc, title }) => (
        <DocumentEditingDetailCard
          key={title}
          logoSrc={logoSrc}
          title={title}
          rightActionText={intl.formatMessage({
            id: 'DocumentEditingIntegrations.config',
            defaultMessage: 'Configure',
            description:
              'Button text for configuring document editing integration',
          })}
        />
      ))}
    </CardList>
  );
}

export default DocumentEditingIntegrations;
